<phx-card-base
  [phxHeader]="phxNewHeaderEnabled ? newHeader : isMobile && phxEditMode ? mobileEditModeHeader : defaultHeader"
  [phxBody]="body"
  [phxWidth]="phxWidth"
></phx-card-base>

<ng-template #body>
  <div class="phx-form-card-body">
    <div class="phx-form-card-body-inner">
      <div class="phx-form-card-description-container">
        <ng-content select="[phx-form-card-description]"></ng-content>
      </div>
      <div class="phx-form-card-banner-container">
        <ng-content *ngIf="!phxEditMode" select="[phx-view-mode-banner]"></ng-content>
        <ng-content *ngIf="phxEditMode" select="[phx-edit-mode-banner]"></ng-content>
      </div>
      <div class="phx-form-card-body-container">
        <div *ngIf="!phxEditMode" class="phx-form-card-view-body">
          <ng-content select="[phx-view-mode-body]"></ng-content>
        </div>
        <div *ngIf="phxEditMode" class="phx-form-card-edit-body">
          <ng-content select="[phx-edit-mode-body]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #title>
  <div class="phx-form-card-title">
    <ng-content select="[phx-form-card-title]"></ng-content>
  </div>
</ng-template>

<ng-template #mobileEditModeHeader>
  <div class="phx-form-card-header">
    <div class="phx-form-card-header-left-content">
      <ng-content select="[phx-header-left-content]"></ng-content>
    </div>
    <ng-container *ngTemplateOutlet="title"></ng-container>
    <div class="phx-form-card-header-right-content">
      <ng-content select="[phx-header-right-content]"></ng-content>
    </div>
  </div>
</ng-template>

<ng-template #defaultHeader>
  <div class="phx-form-card-header">
    <ng-container *ngTemplateOutlet="title"></ng-container>
    <ng-container *ngIf="!phxEditMode">
      <div class="phx-form-card-actions">
        <ng-content select="[phx-view-mode-action-bar]"></ng-content>
      </div>
    </ng-container>
    <ng-container *ngIf="phxEditMode">
      <div class="phx-form-card-actions">
        <ng-content select="[phx-edit-mode-action-bar]"></ng-content>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #newHeader>
  <div class="phx-form-card-new-header">
    <ng-content select="[phx-form-card-header]"></ng-content>
  </div>
</ng-template>
